export const emailEventTypes =
{
    0: 'Alarm raised',
    1: 'On approval',
    2: 'On rejection',
    3: 'On ticket status changed'
};